module.exports = __webpack_public_path__ + "img/logo.svg";


//////////////////
// WEBPACK FOOTER
// ./img/logo.svg
// module id = 233
// module chunks = 0